import { Fragment, jsx } from "react/jsx-runtime";
import React, { cloneElement } from "react";
import cx from "classnames";
import { TypographyPrefixedContext } from "@ingka/typography-shared";
const TextWrapper = (props) => {
  const {
    prefix = "",
    className,
    textStyle = "Body.M",
    colour = true,
    children
  } = props;
  const typography = new TypographyPrefixedContext(prefix);
  const { typographyClassName, textStyleGroup } = typography.fromTextStyleName(textStyle);
  const baseClass = `${prefix}text`;
  const childArray = React.Children.toArray(children);
  return /* @__PURE__ */ jsx(Fragment, { children: childArray.map((child) => {
    if (React.isValidElement(child)) {
      return cloneElement(
        child,
        {
          className: cx(
            colour && baseClass,
            typographyClassName,
            colour && ["Body", "Caption"].includes(textStyleGroup) ? `${baseClass}--lighter` : "",
            className,
            child.props.className || ""
          )
        }
      );
    }
    return child;
  }) });
};
var TextWrapper_default = TextWrapper;
export {
  TextWrapper_default as default
};
